import PropTypes from 'prop-types';
import { Box, Chip, Stack, Typography } from '@mui/material';

const VariablePalette = ({ variables = [], onInsert, readOnly = false, height = 320 }) => {
  const grouped = variables.reduce((acc, item) => {
    const group = item.group || 'Variables';
    if (!acc[group]) acc[group] = [];
    acc[group].push(item);
    return acc;
  }, {});

  const handleDragStart = (event, key, label) => {
    event.dataTransfer.setData('text/plain', `{{${key}}}`);
    event.dataTransfer.effectAllowed = 'copyMove';

    // Ensure the drag preview represents only the dragged token.
    const ghost = document.createElement('div');
    ghost.style.position = 'fixed';
    ghost.style.top = '-9999px';
    ghost.style.left = '-9999px';
    ghost.style.padding = '4px 10px';
    ghost.style.borderRadius = '999px';
    ghost.style.border = '1px solid #cbd5e1';
    ghost.style.background = '#eef6ff';
    ghost.style.color = '#0f172a';
    ghost.style.fontSize = '12px';
    ghost.style.fontWeight = '600';
    ghost.style.pointerEvents = 'none';
    ghost.textContent = label || key;
    document.body.appendChild(ghost);
    event.dataTransfer.setDragImage(ghost, 8, 8);
    window.setTimeout(() => {
      if (ghost.parentNode) ghost.parentNode.removeChild(ghost);
    }, 0);
  };

  return (
    <Box
      sx={{
        border: '1px solid',
        borderColor: 'divider',
        borderRadius: 1.5,
        p: 1,
        height,
        overflow: 'auto',
        bgcolor: 'background.paper',
      }}
    >
      {Object.entries(grouped).map(([group, items]) => (
        <Box key={group} sx={{ mb: 1.5 }}>
          <Typography variant="caption" color="text.secondary" sx={{ fontWeight: 600 }}>
            {group}
          </Typography>
          <Stack direction="row" flexWrap="wrap" gap={1} sx={{ mt: 0.5 }}>
            {items.map((item) => (
              <Chip
                key={item.key}
                size="small"
                label={item.label || item.key}
                draggable={!readOnly}
                onDragStart={(e) => handleDragStart(e, item.key, item.label || item.key)}
                onClick={() => !readOnly && onInsert?.(item.key)}
                sx={{
                  cursor: readOnly ? 'default' : 'grab',
                }}
              />
            ))}
          </Stack>
        </Box>
      ))}
    </Box>
  );
};

VariablePalette.propTypes = {
  variables: PropTypes.arrayOf(PropTypes.shape({
    key: PropTypes.string.isRequired,
    label: PropTypes.string,
    group: PropTypes.string,
  })),
  onInsert: PropTypes.func,
  readOnly: PropTypes.bool,
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};

export default VariablePalette;
